import React,{useEffect, useRef} from 'react'
import { useState } from 'react'


import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { useAppData } from '../../../../../../context/AppDataContext';
import ConfirmDialog from '../../../../../../components/ConfirmDialog';
import { Print } from '@mui/icons-material';
import FinanceLayout from '../../../../../../layout/components/FinanceLayout';
import TermsTemplateForm from '../components/TermsTemplateForm';
import termsTemplateServices from '../termsTemplateServices';
import { useAlert } from '../../../../../../context/AlertContext';




const CellActions = (props) =>{
    return(
        <>
            <TermsTemplateForm  callBack={props.callBack} data={props.data} />
            <ConfirmDialog id={props.data.id} confirm={ ()=>props.remove(props.data.id)} >Are you Sure You want to remove</ConfirmDialog>
        </>
    )
  }


function TermsTemplateListPage() {

  const {getMasterLabel} = useAppData()
  const [termsTemplateList,setTermsTemplateList] = useState(null)
  const {AppAlert} = useAlert();

  const getTermsTemplateList = () =>{
    termsTemplateServices.getList().then(res=>{
      setTermsTemplateList(res.data);
    }).catch(error=>{

    })
  }


  const gridRef = useRef();
  

  const remove = (id) =>{
    termsTemplateServices.remove(id).then(res=>{
      AppAlert("Template Removed Successfully");
      getTermsTemplateList();
    }).catch(error=>{

    })
  }

  const [defaultColDef] = useState({
    floatingFilter: true,
    filterParams: {
      buttons: ['apply'],
    },
    resizable: true,
    width:120,
    filter:true,
    sortable: true,
    cellStyle: { 'textTransform': 'uppercase' },
  });


  const [columnDefs,setColumnDef] = useState();
    const prepairColumnDef = () => {
    let _columnDefs = [
        {field:"id",headerName: "ID"},
        {field:"title",headerName: "Title",width:250},
        
        
        {headerName:"Action", width:"200", valueGetter: params => params.data.title,
            cellRenderer: CellActions,
            cellRendererParams: {
                callBack:getTermsTemplateList,
                remove:remove
            },
        },      
    ];
    setColumnDef(_columnDefs);
  }

  const onBtnExport = () => {
    gridRef.current.api.exportDataAsCsv("data.csv");
  };

  useEffect(()=>{    
    prepairColumnDef();
  },[]);

  const termsTemplateCallBack = () =>{
    getTermsTemplateList();
  }
  return (
    <FinanceLayout>
      <div className='row'>
        <div className='col-md-6'><h4>Terms Template</h4></div>
        <div className='col-md-6'> 
          <span className='float-end'><TermsTemplateForm callBack={termsTemplateCallBack} /></span>
        </div>
        <div className='col-md-12 mt-2'>
          <div className="ag-theme-alpine" style={{height: 400}}>
              <AgGridReact
                ref={gridRef}
                rowData={termsTemplateList}
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                animateRows={true}
                onGridReady={getTermsTemplateList}
              />
            </div>
          </div>
        </div>
    </FinanceLayout>
    
  )
}

export default TermsTemplateListPage